import * as PropTypes from 'prop-types';
export var propTypes = {
    className: PropTypes.string
};
//# sourceMappingURL=types.js.map